<template>
  <v-slide-y-reverse-transition hide-on-leave>
    <v-list
      v-show="show"
      class="pt-1"
    >
      <h-alert v-if="alert" class="ma-6" v-text="alert" />
      <template
        v-else
        v-for="(item, i) in items"
      >
        <h-item-regular
          v-if="item.type == MenuItemType.NORMAL"
          :key="`i${i}`"
          :item="item"
          :disabled="disabled"
        />
        <h-item-linked
        v-else-if="item.type == MenuItemType.LINKED"
          :key="`i${i}`"
          :item="item"
          :disabled="disabled"
          @unfold="$emit('scroll', i)"
        />
        <h-item-formatted
          v-else-if="item.type == MenuItemType.SELLING_FORMAT"
          :key="`i${i}`"
          :item="item"
          :disabled="disabled"
          @unfold="$emit('scroll', i)"
        />
        <h-item-menu
          v-else-if="item.type == MenuItemType.MENU"
          :key="`i${i}`"
          :item="item"
          :disabled="disabled"
        />
        <h-item-kit
          v-else-if="item.type == MenuItemType.KIT"
          :key="`i${i}`"
          :item="item"
          :disabled="disabled"
        />
        <v-divider
          :key="`d${i}`"
          inset
        />
      </template>
    </v-list>
  </v-slide-y-reverse-transition>
</template>

<script>
  import { mapGetters } from 'vuex'
  import I18n from '@/Mixins/I18n'
  import MenuItemType from '@/Models/Static/MenuItemType'
  import HAlert from '@/Components/Messages/Alert'
  import HItemFormatted from './ItemFormatted'
  import HItemKit from './ItemKit'
  import HItemLinked from './ItemLinked'
  import HItemMenu from './ItemMenu'
  import HItemRegular from './ItemRegular'

  export default {
    mixins: [
      I18n,
    ],

    components: {
      HAlert,
      HItemFormatted,
      HItemKit,
      HItemLinked,
      HItemMenu,
      HItemRegular,
    },

    props: {
      items: {
        required: true,
        type: Array,
      },
      show: {
        required: false,
        type: Boolean,
        default: true,
      },
      disabled: {
        required: false,
        type: Boolean,
        default: false,
      },
      searching: {
        required: true,
        type: Boolean,
      },
    },

    data: () => ({
      MenuItemType,
    }),

    computed: {
      ...mapGetters('catalog', {
        needle: 'needle',
        reallySearching: 'searching',
      }),
      alert () {
        if (this.items.length > 0) {
          return false
        }
        if (! this.searching) {
          return this.__('catalogNoItems')
        }
        return ! this.reallySearching
          ? this.__('searchString')
          : this.__('emptySearch').formatUnicorn(this.needle)
      },
    },
  }
</script>
